import { render } from "./SignUpInfo.vue?vue&type=template&id=7a1e1742&scoped=true"
import script from "./SignUpInfo.vue?vue&type=script&lang=js"
export * from "./SignUpInfo.vue?vue&type=script&lang=js"

import "./SignUpInfo.vue?vue&type=style&index=0&id=7a1e1742&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a1e1742"]])

export default __exports__